import { render, staticRenderFns } from "./HeroImage.vue?vue&type=template&id=4e601a5b&scoped=true&"
import script from "./HeroImage.vue?vue&type=script&lang=js&"
export * from "./HeroImage.vue?vue&type=script&lang=js&"
import style0 from "./HeroImage.vue?vue&type=style&index=0&id=4e601a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e601a5b",
  null
  
)

export default component.exports